export default __webpack_public_path__ + "static/sos_alarm_logo-5270e98691536db8589f7587645f1b02.png";